import I18n from "i18n-js";
import React from "react";

export default class BuilderSidebar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="BuilderSidebar">
        <div className="BuilderElements">{this.props.children}</div>
      </div>
    );
  }
}
